import React from 'react';

var Info = function Info(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 18h3v-7H8a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1v9l-1-1h4c1.333 0 1.333 2 0 2H8a1 1 0 0 1 0-2zm4-11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Info.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Info as icon };
export default iconHandler(Info);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Info.js
// module id = 603
// module chunks = 0